import {HttpParams} from '@angular/common/http';
import {Component, Input, OnInit, Optional, Self} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import {PerimetercategoryService} from '@mcv/coreservices';
import {McvnotifierService} from '@mcv/ui';
import {map, tap} from 'rxjs/operators';

@Component({
    selector: 'mcv-category-select',
    templateUrl: './category-select.component.html',
    styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent implements OnInit, ControlValueAccessor {
    @Input() level = 0;
    @Input() value: string = null;
    @Input() disabled: boolean;
    items: { value: number, label: string }[];
    loading = false;

    constructor(private perimetercategoryService: PerimetercategoryService,
                @Self() @Optional() public control: NgControl,
                private notifierService: McvnotifierService) {
        this.control && (this.control.valueAccessor = this);
    }

    onChange: any = (val: number) => {
    };

    onTouch: any = (val: number) => {
    };

    ngOnInit(): void {
        if (!this.items) {
            this.loadItems();
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(obj: any): void {
        if (obj) {
            this.value = obj;
        }
    }

    loadItems() {
        const httpParams: HttpParams = new HttpParams().set('level', this.level.toString());
        this.loading = true;
        this.perimetercategoryService
            .getList(1, 9999, httpParams)
            .pipe(
                map(r => r.data),
                tap(_ => this.loading = false)
            )
            .toPromise()
            .then(r => {
                this.items = r.map(p => ({value: p.id, label: p.label, root_cat: p.root_cat}));
            })
            .catch(err => {
                this.notifierService.error(err);
                this.loading = false;
            });
    }
}
